// extracted by mini-css-extract-plugin
export default {"selected":"QqiFVNz5sKDMmav64V65","optionLabel":"Iehz9wURdg8lazM0t0wQ","checkbox":"BK6L9a_7SBH8mFP0SgyH","marker":"XPPt_F6HxjYS_6tefVVf","platformLogo":"A3sYv5LYFVKo5SeatbrL"};